import { takeLatest, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { PROFILE_EDIT_SUCCESS, PROFILE_EDIT_ERROR } from '../actions.js';
import { clearEvents } from '../utils.js';

function* onProfileEditSuccess() {
    const data = makeProfileEdit('success');
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onProfileEditError(action) {
    const { error ={
        message: 'error'
    }  } = action.payload;
    const data = makeProfileEdit(error.message);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeProfileEdit(status) {
    return {
        event: 'myAccount',
        events: {
            category: 'my profile',
            action: {
                block: 'personal details',
                interaction: 'edit',
                status
            }
        }
    };
}
/**
 * Main export
 */ var MyProfileSagas = [
    takeLatest(PROFILE_EDIT_SUCCESS, onProfileEditSuccess),
    takeLatest(PROFILE_EDIT_ERROR, onProfileEditError), 
];

export { MyProfileSagas as default, onProfileEditError, onProfileEditSuccess };
//# sourceMappingURL=profileEdit.js.map
